interface StatusToggleProps {
  active: boolean;
  label: string;
  onToggle: () => void;
}

/**
 * One canonical ACTIVE / INACTIVE control for setup curation.
 * Keep the switch geometry in fixed pixels so it does not drift with font,
 * tracking, or Tailwind scale changes.
 */
export function StatusToggle({ active, label, onToggle }: StatusToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={active}
      aria-label={`${active ? 'Deactivate' : 'Activate'} ${label}`}
      onClick={onToggle}
      className={`inline-flex h-8 min-w-[124px] shrink-0 items-center rounded-full px-3 font-mono text-[10px] font-semibold uppercase tracking-wider leading-none transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-cyan ${
        active ? 'bg-accent-emerald/10 text-accent-emerald' : 'bg-background-dark/70 text-muted'
      }`}
    >
      <span
        aria-hidden="true"
        className={`relative block shrink-0 rounded-full transition-colors ${active ? 'bg-accent-emerald/80' : 'bg-border-color'}`}
        style={{ width: 28, height: 16 }}
      >
        <span
          className="absolute rounded-full bg-white transition-transform"
          style={{
            width: 12,
            height: 12,
            top: 2,
            left: 2,
            transform: active ? 'translateX(12px)' : 'translateX(0)',
          }}
        />
      </span>
      <span className="ml-2.5">{active ? 'Active' : 'Inactive'}</span>
    </button>
  );
}
